export default "__VITE_ASSET__BPGKGQG1__"